import { gen2Request } from 'src/services/gen_2_http_reqs';
import { onSettingsResponse } from '../device_settings_helpers';
import { get } from 'svelte/store';
import { format } from 'svelte-i18n';

const $format = get(format);

/**
 * Initiates the calibration process for a Gen2 dimmer device.
 *
 * @param {Object} device - The Gen2 dimmer device object to be calibrated
 * @param {number} device.channel - The channel identifier of the device
 * @returns {Promise<void>} A promise that resolves when the calibration process has started
 * @throws {Error} If the calibration request fails
 *
 * @description
 * This function sends a calibration request to a Gen2 dimmer device using the 'light.calibrate' method.
 * After sending the request, it handles the response and shows a success toast message if calibration
 * process starts successfully.
 */
export const calibrateDimmerG2 = async (device) => {
	const method = 'light.calibrate';
	const params = {
		id: device?.channel,
	};
	const res = await gen2Request(device, method, params);
	await onSettingsResponse(res, device, {
		success: $format('calibration_started_scc_toast'),
	});
};
